export const ci = require("../images/ci.png");

export default {
    ci
}